// Secondary images per page id — used for AlliancesBlock and WhyUsBlock
// so we never reuse the hero image on the same page.
export const PAGE_ALT_IMAGES = {
  home: "/images/stock/1573164713988.jpg",
  about: "/images/stock/1552664730.jpg",
  "services-pricing": "/images/stock/1554224155-1696413565d3.jpg",
  contact: "/images/stock/1556761175-5973dc0f32e7.jpg",
  "melbourne-accounting-firm": "/images/stock/1454165804606.jpg",
  "brisbane-accounting-firm": "/images/stock/1521791136064.jpg",
  "canterbury-accounting": "/images/stock/1556761175-b413da4baf72.jpg",
  "chinese-accountants-aus": "/images/stock/1521737711867.jpg",
  "melbourne-accounting-tax": "/images/stock/1454165804606.jpg",
  "individual-tax": "/images/stock/1450101499163.jpg",
  "melbourne-company-personal-tax": "/images/stock/1554224154-22dec7ec8818.jpg",
  "company-tax": "/images/stock/1454165804606.jpg",
  "small-business-tax": "/images/stock/1556761175-b413da4baf72.jpg",
  "business-tax": "/images/stock/1554224154-26032ffc0d07.jpg",
  "tax-deadlines": "/images/stock/1611348586804.jpg",
  "bas-lodgement": "/images/stock/1450101499163.jpg",
  "gst-registration": "/images/stock/1554224155-6726b3ff858f.jpg",
  "tfn": "/images/stock/1554224154-22dec7ec8818.jpg",
  "abn": "/images/stock/1556761175-b413da4baf72.jpg",
  "company-setup": "/images/stock/1556761175-5973dc0f32e7.jpg",
  "smsf": "/images/stock/1556761175-b413da4baf72.jpg",
  "family-trust": "/images/stock/1542744173.jpg",
  "negative-gearing": "/images/stock/1568605114967.jpg",
  "home-office-tax": "/images/stock/1611348586804.jpg",
  "business-travel-tax": "/images/stock/1499591934245.jpg",
  // Blog posts — alt images distinct from each post's hero and from related blog images
  "sole-trader-vs-company": "/images/stock/1568605114967.jpg",
  "division-7a-director-loans": "/images/stock/1573164713988.jpg",
  "cash-flow-management": "/images/stock/1542744173.jpg",
  "single-touch-payroll-stp": "/images/stock/1554224155-1696413565d3.jpg",
  "hospitality-tax-deductions": "/images/stock/1556761175-5973dc0f32e7.jpg",
  "tpar-taxable-payments": "/images/stock/1611348586804.jpg",
  "car-personal-or-company": "/images/stock/1450101499163.jpg",
  "payday-super": "/images/blog/payday-super-alt.jpg",
  "business-structure-guide": "/images/stock/1521737711867.jpg",
  "in-house-vs-outsourced-accounting": "/images/stock/1573164713988.jpg",
  "aml-ctf-tranche-2": "/images/stock/1454165804606.jpg",
};

// Generic stock image pool used as deduplication fallback in ServiceDetailPage —
// when a page needs more images than (hero + alt + related) can provide.
export const STOCK_IMAGE_POOL = [
  "/images/stock/1436491865332.jpg",
  "/images/stock/1450101499163.jpg",
  "/images/stock/1454165804606.jpg",
  "/images/stock/1486406146926.jpg",
  "/images/stock/1497366216548.jpg",
  "/images/stock/1499591934245.jpg",
  "/images/stock/1506784983877.jpg",
  "/images/stock/1511895426328.jpg",
  "/images/stock/1521737711867.jpg",
  "/images/stock/1521791136064.jpg",
  "/images/stock/1542744173.jpg",
  "/images/stock/1551836022.jpg",
  "/images/stock/1552664730.jpg",
  "/images/stock/1554224154-22dec7ec8818.jpg",
  "/images/stock/1554224154-26032ffc0d07.jpg",
  "/images/stock/1554224155-1696413565d3.jpg",
  "/images/stock/1554224155-6726b3ff858f.jpg",
  "/images/stock/1556761175-5973dc0f32e7.jpg",
  "/images/stock/1556761175-b413da4baf72.jpg",
  "/images/stock/1560518883.jpg",
  "/images/stock/1568605114967.jpg",
  "/images/stock/1572025442646.jpg",
  "/images/stock/1573164713988.jpg",
  "/images/stock/1579621970795.jpg",
  "/images/stock/1593642632559.jpg",
  "/images/stock/1611348586804.jpg",
];
